import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { CommonModule, KeyValue } from '@angular/common';
import { Subscription } from 'rxjs';
import { BreadcrumbService } from 'src/app/services/breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb.model';
import { CrumbComponent } from '../crumb/crumb.component';

@Component({
  standalone: true,
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  imports: [
    CommonModule,
    CrumbComponent
  ]
})

export class BreadcrumbComponent implements OnInit, OnDestroy {
  private $subscriptions: Subscription = new Subscription();
  breadcrumbs: Breadcrumb[];
  @Input() enableSwitchTo: boolean;

  constructor(private breadcrumbService: BreadcrumbService) { }

  ngOnInit() {
    this.breadcrumbs = new Array<Breadcrumb>();
    this.subscribeToCrumbAdded();
    this.subscribeToCrumbRemoved();
  }

  private subscribeToCrumbAdded() {
    const addSubscription = this.breadcrumbService.crumbAdded$
      .subscribe(crumb => {
          this.addCrumb(crumb);
      });
    this.$subscriptions.add(addSubscription);
  }

  private subscribeToCrumbRemoved() {
    const addSubscription = this.breadcrumbService.crumbRemoved$
      .subscribe(crumb => {
         this.removeCrumb(crumb);
      });
    this.$subscriptions.add(addSubscription);
  }

  private addCrumb(crumb: Breadcrumb) {
    if (crumb) {
      this.breadcrumbs.push(crumb);
    }
  }

  private removeCrumb(crumb: Breadcrumb) {
    if (crumb) {
      this.breadcrumbs.pop();
    }
  }

  onCrumbClicked($event) {
    const selectedItem = $event as KeyValue<string, string>;
    this.breadcrumbService.crumbSelected(selectedItem);
  }

  onSelectionChange($changeValue) {

  }

  unsubscribe() {
    if (this.$subscriptions) {
        this.$subscriptions.unsubscribe();
    }
  }

  ngOnDestroy(): void {
      this.unsubscribe();
  }
}
